// import React, { useState, useEffect } from "react";
// import httpClient from "../../utils/httpClients";

// function Profile() {
//   const [profileData, setProfileData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [mostPlayedSongs, setMostPlayedSongs] = useState([]);
//   const [subscriptionPlan, setSubscriptionPlan] = useState(null);
//   const [showArtistModal, setShowArtistModal] = useState(false);
//   const [artistRequestData, setArtistRequestData] = useState({
//     displayName: "",
//     image: null,
//     previewUrl: ""
//   });
//   const [requestLoading, setRequestLoading] = useState(false);
//   const [requestSuccess, setRequestSuccess] = useState(null);

//   // Profile edit states
//   const [isEditing, setIsEditing] = useState(false);
//   const [editFormData, setEditFormData] = useState({
//     firstname: "",
//     lastname: "",
//     email: "",
//     currentPassword: "",
//     profileImage: null,
//     profileImagePreview: ""
//   });
//   const [saveLoading, setSaveLoading] = useState(false);
//   const [currentPasswordError, setCurrentPasswordError] = useState("");
//   const [currentPasswordTouched, setCurrentPasswordTouched] = useState(false);

//   useEffect(() => {
//     fetchAccount();
//     fetchSubscriptionPlan();
//   }, []);

//   const fetchAccount = async () => {
//     try {
//       setLoading(true);
//       const res = await httpClient.get("/user/profile/get-profile");
//       if (res.data && res.data.success) {
//         const userData = res.data.data?.userProfile || {};
//         const playmusic = res.data.data?.mostPlayedSongs || {};
//         setProfileData(userData);
//         setMostPlayedSongs(playmusic);

//         // Initialize edit form data
//         setEditFormData({
//           firstname: userData.firstname || "",
//           lastname: userData.lastname || "",
//           email: userData.email || "",
//           currentPassword: "",
//           profileImage: null,
//           profileImagePreview: userData.profilePic || ""
//         });
//       } else {
//         setError("Failed to fetch profile data");
//       }
//     } catch (err) {
//       console.error("Error fetching profile:", err);
//       setError("Error loading profile. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSubscriptionPlan = async () => {
//     try {
//       const res = await httpClient.get("/user/user-subscription/active");
//       if (res.data && res.data.success && res.data.data.activeSubscriptions.length > 0) {
//         // Get the first active subscription
//         const activeSubscription = res.data.data.activeSubscriptions[0];

//         const planData = {
//           _id: activeSubscription._id,
//           name: "Premium Plan",
//           status: activeSubscription.status,
//           startDate: activeSubscription.startDate,
//           endDate: activeSubscription.endDate,
//           autoRenew: activeSubscription.autoRenew,
//           features: [
//             "Unlimited Downloads",
//             "Create Unlimited Playlists",
//             "1GB Storage Space",
//             "High Quality Audio"
//           ],
//           isActive: activeSubscription.status === "active"
//         };

//         setSubscriptionPlan(planData);
//       } else {
//         // No active subscription - set to basic plan
//         setSubscriptionPlan({
//           name: "Basic Listener",
//           status: "inactive",
//           features: [
//             "Limited Downloads",
//             "Create Playlists",
//             "10MB of Storage Space",
//           ],
//           isActive: false,
//         });
//       }
//     } catch (err) {
//       console.error("Error fetching subscription plan:", err);
//       // Fallback to basic plan on error
//       setSubscriptionPlan({
//         name: "Basic Listener",
//         status: "inactive",
//         features: [
//           "Limited Downloads",
//             "Create Playlists",
//             "10MB of Storage Space",
//         ],
//         isActive: false,
//       });
//     }
//   };

//   const handleUpgradePlan = async () => {
//     try {
//       console.log("Upgrade plan clicked");
//       // Add your upgrade logic here
//       // This could redirect to a pricing page or open a payment modal
//     } catch (err) {
//       console.error("Error upgrading plan:", err);
//     }
//   };

//   const handleArtistRequest = () => {
//     setShowArtistModal(true);
//     setRequestSuccess(null);
//   };

//   const handleCloseModal = () => {
//     setShowArtistModal(false);
//     setArtistRequestData({
//       displayName: "",
//       image: null,
//       previewUrl: ""
//     });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setArtistRequestData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setArtistRequestData(prev => ({
//         ...prev,
//         image: file,
//         previewUrl: URL.createObjectURL(file)
//       }));
//     }
//   };

//   const submitArtistRequest = async () => {
//     if (!artistRequestData.displayName.trim()) {
//       setRequestSuccess("Please enter a display name");
//       return;
//     }

//     if (!artistRequestData.image) {
//       setRequestSuccess("Please select an image");
//       return;
//     }

//     try {
//       setRequestLoading(true);

//       const formData = new FormData();
//       formData.append("displayName", artistRequestData.displayName);
//       formData.append("file", artistRequestData.image);

//       const res = await httpClient.post("/user/profile/request-artist-account", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data"
//         }
//       });

//       if (res.data && res.data.success) {
//         setTimeout(() => {
//           setShowArtistModal(false);
//           setArtistRequestData({
//             displayName: "",
//             image: null,
//             previewUrl: ""
//           });
//         }, 2000);
//       } else {
//       }
//     } catch (err) {
//       console.error("Error submitting artist request:", err);
//     } finally {
//       setRequestLoading(false);
//     }
//   };

//   const handleEditInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));

//     // Mark current password as touched only when user types in it
//     if (name === "currentPassword") {
//       setCurrentPasswordTouched(true);
//     }
//   };

//   const handleProfileImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setEditFormData(prev => ({
//         ...prev,
//         profileImage: file,
//         profileImagePreview: URL.createObjectURL(file)
//       }));
//     }
//   };

//   const validateCurrentPassword = () => {
//     if (!currentPasswordTouched) return true;

//     if (!editFormData.currentPassword.trim()) {
//       setCurrentPasswordError("Current password is required to save changes");
//       return false;
//     }

//     if (editFormData.currentPassword.length < 6) {
//       setCurrentPasswordError("Password must be at least 6 characters");
//       return false;
//     }

//     setCurrentPasswordError("");
//     return true;
//   };

//   const handleSaveChanges = async () => {
//     // Only validate current password if the field has been touched
//     if (currentPasswordTouched && !validateCurrentPassword()) {
//       return;
//     }

//     try {
//       setSaveLoading(true);

//       const formData = new FormData();

//       // Only append fields that have changed
//       if (editFormData.firstname !== profileData.firstname) {
//         formData.append("firstname", editFormData.firstname);
//       }

//       if (editFormData.lastname !== profileData.lastname) {
//         formData.append("lastname", editFormData.lastname);
//       }

//       if (editFormData.email !== profileData.email) {
//         formData.append("email", editFormData.email);
//       }

//       // Only append current password if it was provided
//       if (editFormData.currentPassword && currentPasswordTouched) {
//         formData.append("currentPassword", editFormData.currentPassword);
//       }

//       // Only append profile image if a new one was selected
//       if (editFormData.profileImage) {
//         formData.append("profileImage", editFormData.profileImage);
//       }

//       // Check if there are any changes to send
//       if (formData.entries().next().done) {
//         setIsEditing(false);
//         return;
//       }

//       const res = await httpClient.put("/user/profile/update", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data"
//         }
//       });

//       if (res.data && res.data.success) {
//         // Refresh profile data
//         await fetchAccount();
//         setIsEditing(false);
//         setCurrentPasswordTouched(false);
//         setCurrentPasswordError("");
//       } else {
//         setCurrentPasswordError(res.data?.message || "Failed to update profile");
//       }
//     } catch (err) {
//       console.error("Error updating profile:", err);
//       setCurrentPasswordError(err.response?.data?.message || "Error updating profile");
//     } finally {
//       setSaveLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });
//   };

//   if (loading) {
//     return (
//       <div className="content-inner pb-0 container-fluid" id="page_layout">
//         <div
//           className="d-flex justify-content-center align-items-center"
//           style={{ height: "50vh" }}
//         >
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   console.log("profileData",profileData)

//   return (
//     <div className="content-inner pb-0 container-fluid" id="page_layout">
//       {/* Artist Request Modal */}
//       {showArtistModal && (
//         <div className="modal-overlay">
//           <div className="modal-content zoom-anim-dialog modal modal--form eventss">
//             <button className="modal__close" onClick={handleCloseModal}>
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
//                 <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"/>
//               </svg>
//             </button>

//             <h3 className="sign__title border-bottom pb-3">Become an Artist</h3>

//             {requestSuccess ? (
//               <div className={`alert ${requestSuccess.includes("successfully") ? "alert-success" : "alert-danger"}`}>
//                 {requestSuccess}
//               </div>
//             ) : (
//               <form>
//                 <div className="sign__group sign__group--row">
//                   <div className="col-lg-12">
//                     <p>Are you sure you want to become an artist? This will allow you to upload and manage your music.</p>
//                   </div>

//                   <div className="col-lg-12">
//                     <div className="form-group">
//                       <label className="form-label" htmlFor="displayName">Artist Display Name</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="displayName"
//                         name="displayName"
//                         value={artistRequestData.displayName}
//                         onChange={handleInputChange}
//                         placeholder="Enter your artist name"
//                       />
//                     </div>
//                   </div>

//                   <div className="col-lg-12">
//                     <div className="form-group">
//                       <label className="form-label" htmlFor="artistImage">Artist Image</label>
//                       <div className="upload__box">
//                         <div className="upload__btn-box">
//                           <label className="upload__btn">
//                             <p>
//                               <i className="fa-solid fa-upload" /> Upload image
//                             </p>
//                             <input
//                               type="file"
//                               id="artistImage"
//                               name="artistImage"
//                               className="upload__inputfile"
//                               onChange={handleImageChange}
//                               accept="image/*"
//                             />
//                           </label>
//                         </div>
//                       </div>
//                       {artistRequestData.previewUrl && (
//                         <div className="mt-2">
//                           <img
//                             src={artistRequestData.previewUrl}
//                             alt="Preview"
//                             style={{ maxWidth: "100px", maxHeight: "100px" }}
//                           />
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="col-lg-12">
//                     <button
//                       type="button"
//                       className="release__buy"
//                       onClick={submitArtistRequest}
//                       disabled={requestLoading}
//                     >
//                       {requestLoading ? "Submitting..." : "Yes, Become an Artist"}
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             )}
//           </div>
//         </div>
//       )}

//       <div className="row mb-5">
//         <div className="col-lg-12">
//           <div className="card-header">
//             <div className="header-title">
//               <h2 className="card-title text-capitalize mb-3">Profile</h2>
//             </div>
//           </div>
//         </div>

//         <div className="col-xl-3 col-lg-4">
//           <div className="card profile11">
//             <div className="card-header d-flex justify-content-between">
//               <div className="header-title">
//                 <h4 className="card-title">
//                   {isEditing ? (
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="firstname"
//                       value={editFormData.firstname}
//                       onChange={handleEditInputChange}
//                       placeholder="First Name"
//                     />
//                   ) : (
//                     profileData?.firstname || "User"
//                   )}{" "}
//                   {isEditing ? (
//                     <input
//                       type="text"
//                       className="form-control mt-2"
//                       name="lastname"
//                       value={editFormData.lastname}
//                       onChange={handleEditInputChange}
//                       placeholder="Last Name"
//                     />
//                   ) : (
//                     profileData?.lastname || ""
//                   )}
//                 </h4>
//               </div>

//             </div>
//             <div className="card-body profile1">
//               <form>
//                 <div className="form-group">
//                   <div className="profile-img-edit position-relative">
//                     <img
//                       src={
//                         profileData?.displayPic ||
//                         profileData?.profilePic ||
//                         `${process.env.PUBLIC_URL}/assets/images/dashboard/64.png`
//                       }
//                       alt="profile-pic"
//                       className="theme-color-default-img profile-pic rounded avatar-100"
//                       loading="lazy"
//                     />
//                     {isEditing && (
//                       <div className="profile-img-edit-overlay">
//                         <input
//                           type="file"
//                           className="form-control"
//                           onChange={handleProfileImageChange}
//                           accept="image/*"
//                         />
//                         <small className="text-muted d-block mt-1">Click to change image</small>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 <div className="profile-details mt-4">
//                   <div className="detail-item mb-2">
//                     <strong>Email: </strong>
//                     {isEditing ? (
//                       <input
//                         type="email"
//                         className="form-control"
//                         name="email"
//                         value={editFormData.email}
//                         onChange={handleEditInputChange}
//                       />
//                     ) : (
//                       <span>{profileData?.email || "N/A"}</span>
//                     )}
//                   </div>

//                   <div className="detail-item mb-2">
//                     <strong>User Type: </strong>
//                     <span className={`badge ${
//                       profileData?.userType === 'Artist' ? 'bg-success' :
//                       profileData?.userType === 'admin' ? 'bg-danger' : 'bg-primary'
//                     }`}>
//                       {profileData?.userType === 'Artist' ? 'Artist' :
//                        profileData?.userType === 'admin' ? 'Administrator' : 'Listener'}
//                     </span>
//                   </div>

//                   <div className="detail-item mb-2">
//                     <strong>Member since: </strong>
//                     <span>{formatDate(profileData?.createdAt)}</span>
//                   </div>

//                   {profileData?.userType?.includes('User') && profileData?.userType?.includes('Artist') ? (
//   <div className="mt-3">
//     <span className="btn btn-primary">You are already an Artist</span>
//   </div>
// ) : profileData?.userType?.includes('User') && !profileData?.userType?.includes('Artist') ? (
//   <div className="mt-3">
//     <button
//       type="button"
//       className="btn btn-primary"
//       onClick={handleArtistRequest}
//     >
//       Request to be an Artist
//     </button>
//   </div>
// ) : null}

//                   {isEditing && (
//                     <div className="mt-3">
//                       <button
//                         type="button"
//                         className="btn btn-success"
//                         onClick={handleSaveChanges}
//                         disabled={saveLoading}
//                       >
//                         {saveLoading ? "Saving..." : "Save Changes"}
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>

//         <div className="col-12 col-lg-8">
//           <div className="release mt-0">
//             <div className="release__list trending profile11">
//               <ul className="main__list main__list--playlist main__list--dashbox">
//                 <h4 className="card-title text-capitalize episodes">
//                   Most played songs
//                 </h4>

//                 {mostPlayedSongs.length > 0 ? (
//                   mostPlayedSongs.map((song) => (
//                     <SongListItem key={song.id} song={song} />
//                   ))
//                 ) : (
//                   <li className="text-center py-4">No songs played yet</li>
//                 )}
//               </ul>
//             </div>
//           </div>
//         </div>

//         {/* Subscription Plan Section */}
//         <div className="col-12 mt-4">
//           <div className="row justify-content-center">
//             <div className="col-lg-8">
//               {subscriptionPlan && (
//                 <SubscriptionPlan
//                   plan={subscriptionPlan}
//                   onUpgrade={handleUpgradePlan}
//                 />
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .modal-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: rgba(0, 0, 0, 0.7);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 1000;
//           padding: 20px;
//         }

//         .modal-content {
//           background: white;
//           border-radius: 12px;
//           padding: 30px;
//           width: 100%;
//           max-width: 600px;
//           max-height: 90vh;
//           overflow-y: auto;
//           position: relative;
//         }

//         .modal-close {
//           position: absolute;
//           top: 15px;
//           right: 15px;
//           background: none;
//           border: none;
//           cursor: pointer;
//           color: #777;
//           transition: color 0.3s;
//           width: 24px;
//           height: 24px;
//           padding: 0;
//         }

//         .profile-img-edit-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(0, 0, 0, 0.7);
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//           border-radius: 50%;
//           opacity: 0;
//           transition: opacity 0.3s;
//         }

//         .profile-img-edit:hover .profile-img-edit-overlay {
//           opacity: 1;
//         }

//         .profile-img-edit-overlay input {
//           width: 80%;
//           margin-bottom: 5px;
//         }
//       `}</style>
//     </div>
//   );
// }

// // Extracted Song List Item Component
// function SongListItem({ song }) {
//   return (
//     <li className="single-item list-1">
//       <a
//         data-playlist=""
//         data-title={song.title}
//         data-artist={song.artist}
//         data-img="img/covers/cover.svg"
//         href="#"
//         className="single-item__cover"
//         onClick={(e) => e.preventDefault()}
//       >
//         <img src={song.coverImage || "img/covers/cover.svg"} alt={song.title} />
//         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
//           <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
//         </svg>
//       </a>
//       <div className="single-item__title">
//         <h4>
//           <a href="trending-song.html">{song.title}</a>
//         </h4>
//         <span>
//           <a href="artist.html">{song.artist}</a>
//         </span>
//       </div>
//       <div className="dropdown">
//         <span
//           className="d-flex align-items-center h5 mb-0"
//           id={`dropdownMenuButton-${song.id}`}
//           role="button"
//           data-bs-toggle="dropdown"
//           aria-expanded="false"
//         >
//           <i className="fas fa-ellipsis-h" />
//         </span>
//         <div
//           className="dropdown-menu dropdown-menu-end"
//           aria-labelledby={`dropdownMenuButton-${song.id}`}
//         >
//           <a className="dropdown-item" href="#">
//             <span className="material-icons">library_music</span>
//             Add To Playlist
//           </a>
//           <a className="dropdown-item" href="#">
//             <span className="material-icons">playlist_add</span>
//             Add To Queue
//           </a>
//           <a className="dropdown-item" href="#">
//             <span className="material-icons">forward</span>
//             Share
//           </a>
//           <a className="dropdown-item" href="#">
//             <span className="material-icons">music_note</span>
//             Go To Artist
//           </a>
//           <a className="dropdown-item" href="#">
//             <span className="material-icons">album</span>
//             Go To Album
//           </a>
//         </div>
//       </div>
//       <a href="#" className="single-item__add">
//         <i className="far fa-heart" />
//       </a>
//       <a href="#" className="single-item__export">
//         <i className="fas fa-share" />
//       </a>
//       <span className="single-item__time">{song.duration}</span>
//     </li>
//   );
// }

// function SubscriptionPlan({ plan, onUpgrade }) {
//   if (!plan) return null;

//   return (
//     <div className="card pricing-box-2 mb-lg-0">
//       <div className="card-body">
//         <p>Current Plan</p>
//         <h3 className="montlypricing">{plan.name}</h3>
//         <h2 className="my-4 pricingtable__highlight montlypricing my-4">
//           <span className={`badge ${plan.isActive ? 'bg-success' : 'bg-secondary'}`}>
//             {plan.isActive ? "Active" : "Inactive"}
//           </span>
//         </h2>
//         <ul className="p-0 mb-0 list-unstyled yearlypricing">
//           {plan.features &&
//             plan.features.map((feature, index) => (
//               <li key={index}>
//                 <p className="mb-2">
//                   <svg
//                     width={8}
//                     className="me-2"
//                     viewBox="0 0 8 8"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <circle cx={4} cy={4} r={4} fill="currentColor" />
//                   </svg>
//                   {feature}
//                 </p>
//               </li>
//             ))}
//         </ul>

//         {/* Show subscription dates if active */}
//         {plan.isActive && plan.startDate && (
//           <div className="mt-3">
//             <small className="text-muted d-block">
//               Started: {new Date(plan.startDate).toLocaleDateString()}
//             </small>
//             {plan.endDate && (
//               <small className="text-muted d-block">
//                 Expires: {new Date(plan.endDate).toLocaleDateString()}
//               </small>
//             )}
//             {plan.autoRenew !== undefined && (
//               <small className="text-muted d-block">
//                 Auto-renew: {plan.autoRenew ? 'Yes' : 'No'}
//               </small>
//             )}
//           </div>
//         )}

//         {!plan.isActive && (
//           <>
//             <div className="type-2">Recommended</div>
//             <button
//               type="button"
//               className="btn btn-primary border mt-3"
//               onClick={onUpgrade}
//             >
//               Upgrade Now
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Profile;

import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import httpClient from "../../utils/httpClients";
import { usePlayer } from "../../../PlayerContext";
// import Placholder from '../../../../public/img/live/songDefault.png'

function Profile() {
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mostPlayedSongs, setMostPlayedSongs] = useState([]);
  const [subscriptionPlan, setSubscriptionPlan] = useState(null);
  const [showArtistModal, setShowArtistModal] = useState(false);
  const [artistRequestData, setArtistRequestData] = useState({
    displayName: "",
    image: null,
    previewUrl: "",
  });
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestSuccess, setRequestSuccess] = useState(null);

  // Profile edit states
  const [isEditing, setIsEditing] = useState(false);
  const [editFormData, setEditFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    currentPassword: "",
    profileImage: null,
    profileImagePreview: "",
  });
  const [saveLoading, setSaveLoading] = useState(false);
  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [currentPasswordTouched, setCurrentPasswordTouched] = useState(false);

  // Music functionality states from PlayMusic
  const [openDropdown, setOpenDropdown] = useState(null);
  const [likedSongs, setLikedSongs] = useState(new Set());
  const [sharePopup, setSharePopup] = useState({ open: false, song: null });
  const [playCountTracked, setPlayCountTracked] = useState(false);
  const playTimerRef = useRef(null);
  const [genres, setGenres] = useState([]);

  // Playlist functionality states
  const [playlistModal, setPlaylistModal] = useState({
    open: false,
    song: null,
  });
  const [playlists, setPlaylists] = useState([]);
  const [newPlaylist, setNewPlaylist] = useState({
    name: "",
    description: "",
    coverImage: null,
  });
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [playlistLoading, setPlaylistLoading] = useState(false);

  const {
    isPlaying,
    currentTrack,
    togglePlayPause,
    seek,
    duration,
    triggerQueueUpdate,
    playTrackById,
    tracks,
    currentTrackIndex,
  } = usePlayer();
  console.log("subscriptionPlan", subscriptionPlan);
  useEffect(() => {
    fetchAccount();
    fetchSubscriptionPlan();
    fetchGenresSongs();
  }, []);

  // Original Profile Functions
  const fetchAccount = async () => {
    try {
      setLoading(true);
      const res = await httpClient.get("/user/profile/get-profile");
      if (res.data && res.data.success) {
        const userData = res.data.data?.userProfile || {};
        const playmusic = res.data.data?.mostPlayedSongs || [];
        setProfileData(userData);
        setMostPlayedSongs(playmusic);

        // Initialize edit form data
        setEditFormData({
          firstname: userData.firstName || "",
          lastname: userData.lastName || "",
          email: userData.email || "",
          currentPassword: "",
          profileImage: null,
          profileImagePreview: userData.profilePic || "",
        });

        // Initialize liked songs
        const likedSongIds = new Set();
        playmusic.forEach((music) => {
          if (music.isLiked) {
            likedSongIds.add(music._id);
          }
        });
        setLikedSongs(likedSongIds);
      } else {
        setError("Failed to fetch profile data");
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
      setError("Error loading profile. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const fetchSubscriptionPlan = async () => {
    try {
      const res = await httpClient.get("/user/user-subscription/active");
      if (
        res.data &&
        res.data.success &&
        res.data.data.activeSubscriptions.length > 0
      ) {
        const activeSubscription = res.data.data.activeSubscriptions[0];
        const plan = activeSubscription.planId; // Extract plan info

        const planData = {
          _id: activeSubscription._id,
          name: plan.name || "Unnamed Plan",
          type: plan.type || "N/A",
          price: plan.price || 0,
          billingCycle: plan.billingCycle || "N/A",
          currency: plan.currency || "USD",
          status: activeSubscription.status,
          startDate: activeSubscription.startDate,
          endDate: activeSubscription.endDate,
          autoRenew: activeSubscription.autoRenew,
          features: plan.features || [],
          isActive: activeSubscription.status === "active",
        };

        console.log("planc", planData);
        setSubscriptionPlan(planData);
      } else {
        setSubscriptionPlan();
      }
    } catch (err) {
      console.error("Error fetching subscription plan:", err);
      setSubscriptionPlan();
    }
  };

  const handleUpgradePlan = async () => {
    try {
      console.log("Upgrade plan clicked");
    } catch (err) {
      console.error("Error upgrading plan:", err);
    }
  };

  const handleArtistRequest = () => {
    setShowArtistModal(true);
    setRequestSuccess(null);
  };

  const handleCloseModal = () => {
    setShowArtistModal(false);
    setArtistRequestData({
      displayName: "",
      image: null,
      previewUrl: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setArtistRequestData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setArtistRequestData((prev) => ({
        ...prev,
        image: file,
        previewUrl: URL.createObjectURL(file),
      }));
    }
  };

  const submitArtistRequest = async () => {
    if (!artistRequestData.displayName.trim()) {
      setRequestSuccess("Please enter Artist Display Name");
      return;
    }

    if (!artistRequestData.image) {
      setRequestSuccess("Please select an Artist Image");
      return;
    }

    try {
      setRequestLoading(true);

      const formData = new FormData();
      formData.append("displayName", artistRequestData.displayName);
      formData.append("file", artistRequestData.image);

      const res = await httpClient.post(
        "/user/profile/request-artist-account",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.data && res.data.success) {
        setRequestSuccess("Artist request submitted successfully!");
        setTimeout(() => {
          setShowArtistModal(false);
          setArtistRequestData({
            displayName: "",
            image: null,
            previewUrl: "",
          });
          fetchAccount();
        }, 2000);
      } else {
        setRequestSuccess(res.data?.message || "Failed to submit request");
      }
    } catch (err) {
      console.error("Error submitting artist request:", err);
      setRequestSuccess(
        err.response?.data?.message || "Error submitting request",
      );
    } finally {
      setRequestLoading(false);
    }
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "currentPassword") {
      setCurrentPasswordTouched(true);
    }
  };

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditFormData((prev) => ({
        ...prev,
        profileImage: file,
        profileImagePreview: URL.createObjectURL(file),
      }));
    }
  };

  const validateCurrentPassword = () => {
    if (!currentPasswordTouched) return true;

    if (!editFormData.currentPassword.trim()) {
      setCurrentPasswordError("Current password is required to save changes");
      return false;
    }

    if (editFormData.currentPassword.length < 6) {
      setCurrentPasswordError("Password must be at least 6 characters");
      return false;
    }

    setCurrentPasswordError("");
    return true;
  };

  const handleSaveChanges = async () => {
    if (currentPasswordTouched && !validateCurrentPassword()) {
      return;
    }

    try {
      setSaveLoading(true);

      const formData = new FormData();

      if (editFormData.firstname !== profileData.firstName) {
        formData.append("firstname", editFormData.firstname);
      }

      if (editFormData.lastname !== profileData.lastName) {
        formData.append("lastname", editFormData.lastname);
      }

      if (editFormData.email !== profileData.email) {
        formData.append("email", editFormData.email);
      }

      if (editFormData.currentPassword && currentPasswordTouched) {
        formData.append("currentPassword", editFormData.currentPassword);
      }

      if (editFormData.profileImage) {
        formData.append("profileImage", editFormData.profileImage);
      }

      const formDataEntries = Array.from(formData.entries());
      if (formDataEntries.length === 0) {
        setIsEditing(false);
        return;
      }

      const res = await httpClient.put("/user/profile/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data && res.data.success) {
        await fetchAccount();
        setIsEditing(false);
        setCurrentPasswordTouched(false);
        setCurrentPasswordError("");
      } else {
        setCurrentPasswordError(
          res.data?.message || "Failed to update profile",
        );
      }
    } catch (err) {
      console.error("Error updating profile:", err);
      setCurrentPasswordError(
        err.response?.data?.message || "Error updating profile",
      );
    } finally {
      setSaveLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Music Functions from PlayMusic
  const fetchGenresSongs = async () => {
    try {
      setError(null);
      const res = await httpClient.get(`/user/music/get-themes`);

      if (res.data?.success) {
        const data = res.data.data.getThemes || [];
        setGenres(data);
      } else {
        setError("Failed to fetch genre data");
      }
    } catch (err) {
      console.error(err);
      setError("Error fetching genre data");
    }
  };

  const fetchPlaylists = async () => {
    try {
      const res = await httpClient.get("/user/playlist/get-playlists");
      if (res.data && res.data.success) {
        setPlaylists(res.data.data.playlist || []);
      }
    } catch (err) {
      console.error("Error fetching playlists:", err);
    }
  };

  const openPlaylistModal = (song, e) => {
    e.preventDefault();
    e.stopPropagation();
    setPlaylistModal({ open: true, song });
    fetchPlaylists();
    setOpenDropdown(null);
  };

  const closePlaylistModal = () => {
    setPlaylistModal({ open: false, song: null });
    setShowCreateForm(false);
    setNewPlaylist({ name: "", description: "", coverImage: null });
  };

  const createNewPlaylist = async () => {
    if (!newPlaylist.name.trim()) {
      alert("Please enter playlist name");
      return;
    }

    try {
      setPlaylistLoading(true);
      const formData = new FormData();
      formData.append("name", newPlaylist.name);
      formData.append("description", newPlaylist.description);
      if (newPlaylist.coverImage) {
        formData.append("coverImage", newPlaylist.coverImage);
      }

      const res = await httpClient.post(
        "/user/playlist/create-playlist",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.data && res.data.success) {
        await fetchPlaylists();
        setShowCreateForm(false);
        setNewPlaylist({ name: "", description: "", coverImage: null });

        if (playlistModal.song) {
          await addToPlaylist(
            res.data.data.playlist._id,
            playlistModal.song._id,
          );
        }
      }
    } catch (err) {
      console.error("Error creating playlist:", err);
      alert("Failed to create playlist");
    } finally {
      setPlaylistLoading(false);
    }
  };

  const addToPlaylist = async (playlistId, songId) => {
    try {
      const params = new URLSearchParams({
        playlistId: playlistId,
        itemId: songId,
        itemType: "Music",
      });

      const res = await httpClient.post(`/user/playlist/add-item?${params}`);

      if (res.data && res.data.success) {
        closePlaylistModal();
      }
    } catch (err) {
      console.error("Error adding song to playlist:", err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewPlaylist((prev) => ({
        ...prev,
        coverImage: file,
      }));
    }
  };

  const openSharePopup = (song, e) => {
    e.preventDefault();
    e.stopPropagation();
    setSharePopup({ open: true, song });
  };

  const closeSharePopup = () => {
    setSharePopup({ open: false, song: null });
  };

  const handleCopy = async () => {
    const text = generateShareableUrl(sharePopup.song._id);

    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Failed to copy: ", err);
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";

      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
      } catch (err) {
        alert("Failed to copy text!");
      }

      document.body.removeChild(textArea);
    }
  };

  const isSongCurrentlyPlaying = (songId) => {
    return currentTrack && currentTrack._id === songId;
  };

  const getQueuePosition = (songId) => {
    const index = tracks.findIndex((track) => track._id === songId);
    return index >= 0 ? index + 1 : null;
  };

  const handleQueueAction = async (action, trackId = null) => {
    try {
      const payload = { action };
      if (trackId) {
        payload.trackId = trackId;
      }

      const res = await httpClient.post(
        "user/queue/queue-controller",
        payload,
        { skipLoader: true, skipErrorToast: true },
      );

      if (res.data && res.data.success) {
        triggerQueueUpdate();
        return true;
      } else {
        console.error("Queue action failed:", res.data);
        return false;
      }
    } catch (error) {
      console.error("Queue action error:", error);
      return false;
    }
  };

  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const handleLikeSong = async (contentId, isCurrentlyLiked) => {
    const newLiked = !isCurrentlyLiked;
    const prevLikedSongs = new Set(likedSongs);
    const prevMusics = [...mostPlayedSongs];

    const newLikedSongs = new Set(likedSongs);
    if (isCurrentlyLiked) newLikedSongs.delete(contentId);
    else newLikedSongs.add(contentId);
    setLikedSongs(newLikedSongs);

    const updatedMusics = mostPlayedSongs.map((music) =>
      music._id === contentId ? { ...music, isLiked: newLiked } : music,
    );
    setMostPlayedSongs(updatedMusics);

    try {
      const action = isCurrentlyLiked ? "dislike" : "like";
      const res = await httpClient.post(
        `/user/play-history/like-content/${contentId}/${action}`,
        {},
        { skipToast: true, skipLoader: true },
      );
      if (!res.data?.success) {
        setLikedSongs(prevLikedSongs);
        setMostPlayedSongs(prevMusics);
      }
    } catch (err) {
      console.error("Error liking/disliking song:", err);
      setLikedSongs(prevLikedSongs);
      setMostPlayedSongs(prevMusics);
    }
  };

  const playSong = async (song, index) => {
    console.log("🎵 Playing song from profile:", song.title, "ID:", song._id);

    if (isSongCurrentlyPlaying(song._id)) {
      togglePlayPause();
      return;
    }

    try {
      const success = await playTrackById(song._id, "audio");

      if (success) {
        console.log("✅ Song queued and playing:", song.title);
        setTimeout(() => {
          if (!isPlaying) {
            togglePlayPause();
          }
        }, 1000);
      } else {
        console.error("❌ Failed to play song");
      }
    } catch (error) {
      console.error("Error playing song:", error);
    }
  };

  // Play count is recorded only by PlayerContext (single source of truth)

  const addToQueue = async (trackId) => {
    await handleQueueAction("add", trackId);
  };

  const sendToArtist = (artistId) => {
    if (artistId) navigate(`/art/${artistId}`);
  };

  const sendToAlbum = (albumId, isAlbum) => {
    if (isAlbum && albumId) navigate(`/album/${albumId}`);
  };

  const toggleDropdown = (contentId) => {
    setOpenDropdown(openDropdown === contentId ? null : contentId);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown")) {
        setOpenDropdown(null);
      }
      if (
        !event.target.closest(".share-popup") &&
        !event.target.closest(".single-item__export")
      ) {
        closeSharePopup();
      }
      if (
        !event.target.closest(".playlist-popup") &&
        !event.target.closest(".dropdown-item")
      ) {
        closePlaylistModal();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const generateShareableUrl = (songId) => {
    const encodedSongId = encodeURIComponent(songId);
    // return `https://webmobrildemo.com/volumetv/music/${encodedSongId}`;
    return `${process.env.REACT_APP_FRONTEND_URL || window.location.origin}music/${encodeURIComponent(songId)}`;
  };

  const shareOnSocialMedia = (platform, song) => {
    const shareUrl = generateShareableUrl(song._id);
    const shareText = encodeURIComponent(song.title);

    const shareUrls = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
      twitter: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareText}`,
      whatsapp: `https://api.whatsapp.com/send?text=${shareText}%20${shareUrl}`,
      telegram: `https://t.me/share/url?url=${shareUrl}&text=${shareText}`,
    };

    if (shareUrls[platform]) {
      window.open(shareUrls[platform], "_blank", "width=600,height=400");
    }
  };

  // React Slick settings for genres carousel
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const CustomNextArrow = () => (
    <div
      className="swiper-button-next"
      id="next1"
      tabIndex={0}
      role="button"
      aria-label="Next slide"
      onClick={() => sliderRef.current && sliderRef.current.slickNext()}
      style={{ cursor: "pointer" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
      >
        <path
          d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );

  const CustomPrevArrow = () => (
    <div
      className="swiper-button-prev"
      id="prev1"
      tabIndex={0}
      role="button"
      aria-label="Previous slide"
      onClick={() => sliderRef.current && sliderRef.current.slickPrev()}
      style={{ cursor: "pointer" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
      >
        <path
          d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
          fill="#4A525F"
        />
      </svg>
    </div>
  );

  // Helper functions for profile
  const isUserArtist = () => {
    return profileData?.userType?.includes("Artist");
  };

  const getArtistAccountStatus = () => {
    return profileData?.artistAccountStatus;
  };

  if (loading) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      {/* Artist Request Modal */}
      {showArtistModal && (
        <div className="modal-overlay">
          <div
            className="modal-content zoom-anim-dialog modal modal--form eventss"
            style={{ marginBottom: "13%" }}
          >
            <button className="modal__close" onClick={handleCloseModal}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
              </svg>
            </button>

            <h3 className="sign__title border-bottom pb-3">Become an Artist</h3>

            {/* {requestSuccess ? (
              <div
                className={`alert ${requestSuccess.includes("successfully") ? "alert-success" : "alert-danger"}`}
              >
                {requestSuccess}
              </div>
            ) :  */}
            {/* {!requestSuccess && ( */}
            <form>
              <div className="sign__group sign__group--row">
                <div className="col-lg-12">
                  <p>
                    Are you sure you want to become an artist? This will allow
                    you to upload and manage your music.
                  </p>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="form-label" htmlFor="displayName">
                      Artist Display Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="displayName"
                      name="displayName"
                      value={artistRequestData.displayName}
                      onChange={handleInputChange}
                      placeholder="Enter your artist name"
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="form-label" htmlFor="artistImage">
                      Artist Image <span className="text-danger">*</span>
                    </label>
                    <div className="upload__box">
                      <div className="upload__btn-box">
                        <label className="upload__btn">
                          <p>
                            <i className="fa-solid fa-upload" /> Upload image
                          </p>
                          <input
                            type="file"
                            id="artistImage"
                            name="artistImage"
                            className="upload__inputfile"
                            onChange={handleImageChange}
                            accept="image/*"
                          />
                        </label>
                      </div>
                    </div>
                    {artistRequestData.previewUrl && (
                      <div className="mt-2">
                        <img
                          src={artistRequestData.previewUrl}
                          alt="Preview"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">
                  <button
                    type="button"
                    className="release__buy"
                    onClick={submitArtistRequest}
                    disabled={requestLoading}
                  >
                    {requestLoading ? "Submitting..." : "Yes, Become an Artist"}
                  </button>
                  {requestSuccess && (
                    <div
                      className={`alert ${requestSuccess.includes("successfully") ? "text-success" : "text-danger"}`}
                    >
                      {requestSuccess}
                    </div>
                  )}
                </div>
              </div>
            </form>
            {/* )} */}
          </div>
        </div>
      )}

      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="card-header">
            <div className="header-title">
              <h2 className="card-title text-capitalize mb-3">Profile</h2>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-lg-4">
          <div className="card profile11">
            <div className="card-body profile1">
              <form>
                <div className="form-group mt-4">
                  <div className="profile-img-edit position-relative">
                    <img
                      src={
                        profileData?.profilePic ||
                        `${process.env.PUBLIC_URL}/assets/images/dashboard/mode-portrait.png`
                      }
                      alt="profile-pic"
                      className="theme-color-default-img profile-pic rounded avatar-100"
                      loading="lazy"
                      style={{ height: "25vh", objectFit: "contain" }}
                    />
                  </div>
                </div>

                <div className="profile-details mt-4">
                  <div className="detail-item mb-2">
                    <strong>Email: </strong>

                    <span>{profileData?.email || "N/A"}</span>
                  </div>

                  <div className="detail-item mb-2">
                    <strong>User Type: </strong>
                    <span
                      className={`badge ${
                        isUserArtist()
                          ? "bg-success"
                          : profileData?.userType?.includes("admin")
                            ? "bg-danger"
                            : "bg-primary"
                      }`}
                    >
                      {isUserArtist()
                        ? "Artist"
                        : profileData?.userType?.includes("admin")
                          ? "Administrator"
                          : "Listener"}
                    </span>
                  </div>

                  {getArtistAccountStatus() &&
                    getArtistAccountStatus() !== "approved" && (
                      <div className="detail-item mb-2">
                        <strong>Artist Status: </strong>
                        <span
                          className={`badge ${
                            getArtistAccountStatus() === "pending"
                              ? "bg-warning"
                              : getArtistAccountStatus() === "rejected"
                                ? "bg-danger"
                                : "bg-secondary"
                          }`}
                        >
                          {getArtistAccountStatus()?.charAt(0).toUpperCase() +
                            getArtistAccountStatus()?.slice(1)}
                        </span>
                      </div>
                    )}

                  <div className="detail-item mb-2">
                    <strong>Member since: </strong>
                    <span>{formatDate(profileData?.createdAt)}</span>
                  </div>

                  {!isUserArtist() && (
                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleArtistRequest}
                      >
                        Request to be an Artist
                      </button>
                    </div>
                  )}

                  {isUserArtist() && (
                    <div className="mt-3">
                      <span className="btn btn-success">
                        You are already an Artist
                      </span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Most Played Songs Section with Music Functionality */}
        <div className="col-12 col-lg-8">
          <div className="release mt-0">
            <div className="release__list trending profile11">
              <ul className="main__list main__list--playlist main__list--dashbox">
                <h4 className="card-title text-capitalize episodes">
                  Most played songs
                </h4>

                {mostPlayedSongs.length > 0 ? (
                  mostPlayedSongs.map((music, index) => {
                    const contentId = music?.contentId?._id;
                    const isLiked = likedSongs.has(contentId);
                    const isCurrentlyPlaying =
                      isSongCurrentlyPlaying(contentId);
                    const queuePosition = getQueuePosition(contentId);
                    const isDropdownOpen = openDropdown === contentId;
                    const ArtistId = music?.contentId?.artistIds?.[0];
                    const isAlbum = music?.contentId?.isAlbum;
                    const AlbumId = music?.contentId?.parentId;

                    return (
                      <li
                        key={contentId}
                        className={`single-item list-1 ${
                          isCurrentlyPlaying ? "active-episode" : ""
                        }`}
                        style={{
                          backgroundColor: isCurrentlyPlaying
                            ? "rgba(255, 255, 255, 0.1)"
                            : "transparent",
                          borderLeft: isCurrentlyPlaying
                            ? "3px solid #1DB954"
                            : "3px solid transparent",
                        }}
                      >
                        {/* Song Cover with Play Button */}
                        <div
                          className="single-item__cover"
                          onClick={() => playSong(music, index)}
                          style={{ cursor: "pointer", color: "#fff" }}
                        >
                          <img
                            src={
                              music?.contentId?.coverImageUrl ||
                              `${process.env.PUBLIC_URL}/img/covers/cover.svg`
                            }
                            alt={music?.contentId?.title}
                          />
                          {isCurrentlyPlaying && isPlaying ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              style={{ fill: "#1DB954" }}
                            >
                              <path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              style={{
                                fill: isCurrentlyPlaying
                                  ? "#1DB954"
                                  : "#FFFFFF",
                              }}
                            >
                              <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
                            </svg>
                          )}
                        </div>

                        {/* Song Title and Artist */}
                        <div className="single-item__title">
                          <h4
                            onClick={() =>
                              isAlbum && sendToAlbum(AlbumId, isAlbum)
                            }
                            style={{ cursor: isAlbum ? "pointer" : "default" }}
                          >
                            {index + 1}. {music?.contentId?.title}
                            {isCurrentlyPlaying && (
                              <span
                                className="badge bg-success ms-2"
                                style={{ fontSize: "0.7em", color: "#fff" }}
                              >
                                ▶️ Playing
                              </span>
                            )}
                            {queuePosition && !isCurrentlyPlaying && (
                              <span
                                className="badge bg-info ms-2"
                                style={{ fontSize: "0.7em", color: "#fff" }}
                              >
                                #{queuePosition} in Queue
                              </span>
                            )}
                          </h4>

                          {/* Artist Name clickable */}
                          <span
                            onClick={() => sendToArtist(ArtistId)}
                            style={{
                              cursor: ArtistId ? "pointer" : "default",
                              color: "#1DB954",
                            }}
                          >
                            {music?.contentId?.artist || "Unknown Artist"}
                          </span>
                        </div>

                        {/* Dropdown Menu */}
                        <div className="dropdown">
                          <span
                            className={`d-flex align-items-center h5 mb-0 ${
                              isDropdownOpen ? "show" : ""
                            }`}
                            onClick={() => toggleDropdown(contentId)}
                            aria-expanded={isDropdownOpen}
                            style={{ cursor: "pointer", color: "#fff" }}
                          >
                            <i className="fas fa-ellipsis-h"></i>
                          </span>
                          <div
                            className={`dropdown-menu dropdown-menu-end ${
                              isDropdownOpen ? "show" : ""
                            }`}
                            style={
                              isDropdownOpen
                                ? {
                                    position: "absolute",
                                    inset: "0px 0px auto auto",
                                    margin: "0px",
                                    transform: "translate(0px, 19px)",
                                  }
                                : {}
                            }
                          >
                            <a
                              className="dropdown-item"
                              href="#!"
                              onClick={(e) => openPlaylistModal(music, e)}
                            >
                              <span className="material-icons">
                                library_music
                              </span>
                              Add To Playlist
                            </a>
                            <a
                              className="dropdown-item"
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                addToQueue(contentId);
                                setOpenDropdown(null);
                              }}
                            >
                              <span className="material-icons">
                                playlist_add
                              </span>
                              Add To Queue
                            </a>
                            <a
                              className={`dropdown-item ${
                                !ArtistId ? "disabled" : ""
                              }`}
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                if (ArtistId) {
                                  sendToArtist(ArtistId);
                                  setOpenDropdown(null);
                                }
                              }}
                            >
                              <span className="material-icons">music_note</span>
                              Go To Artist
                            </a>

                            <a
                              className={`dropdown-item ${
                                !isAlbum ? "disabled" : ""
                              }`}
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                if (isAlbum) {
                                  sendToAlbum(AlbumId, isAlbum);
                                  setOpenDropdown(null);
                                }
                              }}
                            >
                              <span className="material-icons">album</span>
                              Go To Album
                            </a>
                          </div>
                        </div>

                        {/* Like Button */}
                        <a
                          href="#!"
                          className={`single-item__add ${isLiked ? "liked" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleLikeSong(contentId, isLiked);
                          }}
                        >
                          <i
                            className={
                              isLiked
                                ? "fas fa-heart text-danger"
                                : "far fa-heart"
                            }
                          ></i>
                        </a>

                        {/* Share Button */}
                        <a
                          href="#!"
                          className="single-item__export"
                          onClick={(e) => openSharePopup(music, e)}
                        >
                          <i className="fas fa-share"></i>
                        </a>

                        {/* Time Display */}
                        <span className="single-item__time">
                          {isCurrentlyPlaying
                            ? `${formatDuration(seek)} / ${formatDuration(duration)}`
                            : formatDuration(music.contentId?.duration)}
                        </span>
                      </li>
                    );
                  })
                ) : (
                  <li className="text-center py-4">No songs played yet</li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Subscription Plan Section */}
        {subscriptionPlan && (
          <div className="col-12 mt-4">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="card pricing-box-2 mb-lg-0">
                  <div className="card-body">
                    <p>Subscribed to</p>
                    <h3 className=" montlypricing">{subscriptionPlan.name}</h3>
                    <h3 className="yearlypricing">{subscriptionPlan.name}</h3>
                    <h2 className="my-4 pricingtable__highlight montlypricing my-4">
                      <b />
                    </h2>
                    <h2 className="my-4 pricingtable__highlight yearlypricing my-4">
                      {subscriptionPlan.price}/{subscriptionPlan.billingCycle}{" "}
                      <b />
                    </h2>
                    <ul className="p-0 mb-0 list-unstyled yearlypricing">
                      {subscriptionPlan.features &&
                        subscriptionPlan.features.map((feature, index) => (
                          <li key={index}>
                            <p className="mb-2">
                              <svg
                                width={8}
                                className="me-2"
                                viewBox="0 0 8 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle
                                  cx={4}
                                  cy={4}
                                  r={4}
                                  fill="currentColor"
                                />
                              </svg>
                              {feature}
                            </p>
                          </li>
                        ))}
                    </ul>
                    {subscriptionPlan.isActive &&
                      subscriptionPlan.startDate && (
                        <div className="mt-3">
                          <small className="text-muted d-block">
                            Started: {formatDate(subscriptionPlan.startDate)}
                          </small>
                          {subscriptionPlan.endDate && (
                            <small className="text-muted d-block">
                              Expires: {formatDate(subscriptionPlan.endDate)}
                            </small>
                          )}
                          {subscriptionPlan.autoRenew !== undefined && (
                            <small className="text-muted d-block">
                              Auto-renew:{" "}
                              {subscriptionPlan.autoRenew ? "Yes" : "No"}
                            </small>
                          )}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Top Genres Section */}
      <div className="row">
        <div className="col-lg-12 mb-5">
          <div className="card-header mb-3">
            <div className="header-title">
              <h4 className="card-title text-capitalize">
                top song genres for you
              </h4>
            </div>
            <div className="common-album position-relative d-lg-block d-none">
              <div
                className="swiper-button-prev"
                id="prev"
                tabIndex={0}
                role="button"
                aria-label="Previous slide"
                aria-controls="swiper-wrapper-eff510bae5fc34b53"
                onClick={() => sliderRef.current?.slickPrev()}
                style={{ cursor: "pointer" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
                    fill="#4A525F"
                  ></path>
                </svg>
              </div>
              <div
                className="swiper-button-next"
                id="next"
                tabIndex={0}
                role="button"
                aria-label="Next slide"
                aria-controls="swiper-wrapper-eff510bae5fc34b53"
                onClick={() => sliderRef.current?.slickNext()}
                style={{ cursor: "pointer" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </div>
            </div>
          </div>

          <div className="swiper overflow-hidden" data-swiper="geners-slider">
            <Slider ref={sliderRef} {...sliderSettings}>
              {genres.map((genre) => (
                <div key={genre._id} className="swiper-slide mb-3">
                  <Link
                    to={`/party-music/${genre._id}`}
                    className="text-capitalize line-count-1 h5 d-block"
                  >
                    <img
                      src={genre.themeImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`}
                      id={genre._id}
                      className="mb-3 img-fluid rounded-3"
                      alt="song-img"
                      style={{ height: "180px", objectFit: "cover" }}
                    />
                    {genre.name}
                  </Link>
                  <small className="fw-normal text-capitalize line-count-1">
                    {genre.description}
                  </small>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      {/* Share Popup */}
      {sharePopup.open && sharePopup.song && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="share-popup"
            style={{
              backgroundColor: "#1a1a1a",
              padding: "25px",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "350px",
              color: "white",
              border: "1px solid #333",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginBottom: "25px",
              }}
            >
              <h4
                style={{
                  margin: "0 0 10px 0",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#aaa7a7",
                }}
              >
                Share
              </h4>
              <p
                style={{
                  margin: 0,
                  color: "#ccc",
                  fontSize: "14px",
                }}
              >
                {sharePopup.song.title}
              </p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "25px",
              }}
            >
              <button
                onClick={() => shareOnSocialMedia("facebook", sharePopup.song)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#1877f2",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "12px",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#1877f2",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  <i
                    className="fab fa-facebook-f"
                    style={{ color: "white" }}
                  ></i>
                </div>
                Facebook
              </button>

              <button
                onClick={() => shareOnSocialMedia("twitter", sharePopup.song)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#1da1f2",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "12px",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#1da1f2",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  <i className="fab fa-twitter" style={{ color: "white" }}></i>
                </div>
                Twitter
              </button>

              <button
                onClick={() => shareOnSocialMedia("whatsapp", sharePopup.song)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#25d366",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "12px",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#25d366",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  <i className="fab fa-whatsapp" style={{ color: "white" }}></i>
                </div>
                Whatsapp
              </button>

              <button
                onClick={() => shareOnSocialMedia("telegram", sharePopup.song)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#0088cc",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "12px",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#0088cc",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  <i className="fab fa-telegram" style={{ color: "white" }}></i>
                </div>
                Telegram
              </button>
            </div>

            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                value={generateShareableUrl(sharePopup.song._id)}
                readOnly
                style={{
                  flex: 1,
                  padding: "12px 15px",
                  backgroundColor: "#2a2a2a",
                  border: "1px solid #444",
                  borderRadius: "8px",
                  color: "white",
                  fontSize: "14px",
                }}
              />
              <button
                onClick={handleCopy}
                style={{
                  padding: "12px 20px",
                  backgroundColor: "#1DB954",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                COPY
              </button>
            </div>

            <button
              onClick={closeSharePopup}
              style={{
                width: "100%",
                marginTop: "20px",
                padding: "12px",
                backgroundColor: "transparent",
                color: "#ccc",
                border: "1px solid #444",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      )}

      {/* Playlist Modal */}
      {playlistModal.open && playlistModal.song && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="playlist-popup"
            style={{
              backgroundColor: "#1a1a1a",
              padding: "25px",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "400px",
              color: "white",
              border: "1px solid #333",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  margin: "0 0 10px 0",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#ffff",
                }}
              >
                Add to Playlist
              </h4>
              <p
                style={{
                  margin: 0,
                  color: "#ccc",
                  fontSize: "14px",
                }}
              >
                {playlistModal.song.title}
              </p>
            </div>

            {!showCreateForm ? (
              <>
                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    marginBottom: "20px",
                  }}
                >
                  {playlists.length > 0 ? (
                    playlists.map((playlist) => (
                      <div
                        key={playlist._id}
                        style={{
                          padding: "12px",
                          border: "1px solid #333",
                          borderRadius: "8px",
                          marginBottom: "8px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={() =>
                          addToPlaylist(playlist._id, playlistModal.song._id)
                        }
                      >
                        <img
                          src={
                            playlist.playlistCoverUrl ||
                            "/img/live/songDefault.png"
                          }
                          alt={playlist.name}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "4px",
                            objectFit: "cover",
                          }}
                        />
                        <div>
                          <div style={{ fontWeight: "500" }}>
                            {playlist.name}
                          </div>
                          {playlist.description && (
                            <div style={{ fontSize: "12px", color: "#ccc" }}>
                              {playlist.description}
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#ccc",
                      }}
                    >
                      No playlists found
                    </div>
                  )}
                </div>

                <button
                  onClick={() => setShowCreateForm(true)}
                  style={{
                    width: "100%",
                    padding: "12px",
                    backgroundColor: "#1DB954",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  Create New Playlist
                </button>
              </>
            ) : (
              <div>
                <div style={{ marginBottom: "15px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontSize: "14px",
                    }}
                  >
                    Playlist Name *
                  </label>
                  <input
                    type="text"
                    value={newPlaylist.name}
                    onChange={(e) =>
                      setNewPlaylist((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    placeholder="Enter playlist name"
                    style={{
                      width: "100%",
                      padding: "10px",
                      backgroundColor: "#2a2a2a",
                      border: "1px solid #444",
                      borderRadius: "6px",
                      color: "white",
                      fontSize: "14px",
                    }}
                  />
                </div>

                <div style={{ marginBottom: "15px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontSize: "14px",
                    }}
                  >
                    Description
                  </label>
                  <textarea
                    value={newPlaylist.description}
                    onChange={(e) =>
                      setNewPlaylist((prev) => ({
                        ...prev,
                        description: e.target.value,
                      }))
                    }
                    placeholder="Enter playlist description"
                    rows="3"
                    style={{
                      width: "100%",
                      padding: "10px",
                      backgroundColor: "#2a2a2a",
                      border: "1px solid #444",
                      borderRadius: "6px",
                      color: "white",
                      fontSize: "14px",
                      resize: "vertical",
                    }}
                  />
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontSize: "14px",
                    }}
                  >
                    Cover Image
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{
                      width: "100%",
                      padding: "8px",
                      backgroundColor: "#2a2a2a",
                      border: "1px solid #444",
                      borderRadius: "6px",
                      color: "white",
                      fontSize: "14px",
                    }}
                  />
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    onClick={createNewPlaylist}
                    disabled={playlistLoading}
                    style={{
                      flex: 1,
                      padding: "12px",
                      backgroundColor: "#1DB954",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: playlistLoading ? "not-allowed" : "pointer",
                      fontSize: "14px",
                      fontWeight: "600",
                      opacity: playlistLoading ? 0.7 : 1,
                    }}
                  >
                    {playlistLoading ? "Creating..." : "Create Playlist"}
                  </button>
                  <button
                    onClick={() => setShowCreateForm(false)}
                    style={{
                      flex: 1,
                      padding: "12px",
                      backgroundColor: "transparent",
                      color: "#ccc",
                      border: "1px solid #444",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {!showCreateForm && (
              <button
                onClick={closePlaylistModal}
                style={{
                  width: "100%",
                  marginTop: "10px",
                  padding: "12px",
                  backgroundColor: "transparent",
                  color: "#ccc",
                  border: "1px solid #444",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                CLOSE
              </button>
            )}
          </div>
        </div>
      )}

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }

        .modal-content {
          background: white;
          border-radius: 12px;
          padding: 30px;
          width: 100%;
          max-width: 600px;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
        }

        .modal-close {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          cursor: pointer;
          color: #777;
          transition: color 0.3s;
          width: 24px;
          height: 24px;
          padding: 0;
        }

        .profile-img-edit-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          opacity: 0;
          transition: opacity 0.3s;
          color: white;
        }

        .profile-img-edit:hover .profile-img-edit-overlay {
          opacity: 1;
        }

        .profile-img-edit-overlay input {
          width: 80%;
          margin-bottom: 5px;
        }

        .profile-img-edit {
          position: relative;
          display: inline-block;
        }

        .profile-img-edit input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}

export default Profile;
